<template>
  <div>
    <b-overlay
      id="overlay-background"
      :show="loader === true"
      variant="dark"
      opacity="0.85"
      blur="2px"
      rounded="sm"
      spinner-variant="primary"
      spinner-medium
    >
      <b-card>
        <div class="m-2">
          <b-row>
            <b-col
              cols="12"
              md="6"
              class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            >
              <label>{{ $t('DEBTIA_SHOWING') }}</label>
              <v-select
                v-model="perPage"
                :clearable="false"
                class="search_by_select per-page-selector d-inline-block mx-50"
                :options="perPageOptions"
              />
              <label>{{ $t('DEBTIA_ENTRIES') }}</label>
            </b-col>
            <b-col
              v-if="!isSuperAdmin"
              cols="12"
              md="6"
            >
              <div class="d-flex align-items-center justify-content-end">
                <b-button
                  v-if="$ability.can(constants.action.permissionApiTokenAdd, constants.resource.apiToken)"
                  v-b-modal.modal-role
                  variant="primary"
                  @click="apiToken(addApiToken)"
                >
                  <span class="text-nowrap">{{ $t('DEBTIA_ADD_API_TOKEN') }}</span>
                </b-button>
              </div>
            </b-col>
          </b-row><br>
          <b-row>
            <b-col
              cols="12"
              md="6"
              class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            >
              <label>{{ $t('DEBTIA_SEARCH_BY') }}</label>
              <v-select
                v-model="searchBy"
                :clearable="false"
                class="search_by_select per-page-selector d-inline-block mx-50"
                :options="searchByOptions"
              />
            </b-col>
            <b-col
              cols="12"
              md="3"
              offset-md="3"
              class="query-input"
            >
              <div class="d-flex align-items-center justify-content-end">
                <b-form-input
                  v-model="searchQuery"
                  class="d-inline-block mr-1"
                  :placeholder="$t('DEBTIA_SEARCH')"
                />
                <b-button
                  variant="primary"
                  @click="searchRecords()"
                >
                  <span class="text-nowrap">{{ $t('DEBTIA_SEARCH') }}</span>
                </b-button>
              </div>
            </b-col>
          </b-row>
        </div>
        <b-table
          ref="roles"
          class="position-relative"
          :fields="tableFields"
          :items="apiTokensData"
        >
          <template #cell(status)="data">
            <b-badge
              pill
              :variant="data.value === 1 ? 'success' : 'warning' "
            >
              {{ data.value === 1 ? 'Active' : 'InActive' }}
            </b-badge>
          </template>
          <template #cell(action)="data">
            <feather-icon
              v-if="$ability.can(constants.action.permissionApiTokenEdit, constants.resource.apiToken)"
              v-b-modal.modal-role
              icon="EditIcon"
              @click="apiToken(data.item)"
            />
            <feather-icon
              v-if="$ability.can(constants.action.permissionApiTokenRevoke, constants.resource.apiToken) && !isSuperAdmin"
              :icon="data.item.status === 1 ? 'XCircleIcon' : 'CheckCircleIcon'"
              :style="data.item.status === 1 ? 'color: rgb(253 164 53);' : 'color: #28c76f;'"
              style="margin-left: 15px;'"
              @click="confirmation(data.item.id,data.item.name, 2, data.item.status)"
            />
            <feather-icon
              v-if="$ability.can(constants.action.permissionApiTokenDelete, constants.resource.apiToken) && !isSuperAdmin"
              icon="Trash2Icon"
              style="margin-left: 15px; color: #ff3737;"
              @click="confirmation(data.item.id,data.item.name, 1, null)"
            />
          </template>
        </b-table>
        <div class="mx-2 mb-2">
          <b-row>

            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted">{{ $t('DEBTIA_SHOWING') }} {{ from }} to {{ to }} of {{ totalPages }} {{ $t('DEBTIA_ENTRIES') }}</span>
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >

              <b-pagination
                v-model="currentPage"
                :total-rows="totalPages"
                :per-page="perPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon
                    icon="ChevronLeftIcon"
                    size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon
                    icon="ChevronRightIcon"
                    size="18"
                  />
                </template>
              </b-pagination>

            </b-col>

          </b-row>
        </div>
        <api-tokens-modal
          :api-tokens-data="editData"
          :modal-loads="modalLoader"
          :show="!modalLoader"
          :reload-method="getApiTokens"
        />
      </b-card>
    </b-overlay>
  </div>
</template>

<script>
import {
  BCard, BOverlay, BTable, BRow, BCol, BFormInput, BButton, BPagination, BBadge,
} from 'bootstrap-vue'
import axios from '@axios'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import vSelect from 'vue-select'
import constants from '@/app-configs/constants'
import i18n from '@/libs/i18n'
import ApiTokensModal from './ApiTokensModal.vue'

export default {
  components: {
    BCard,
    BOverlay,
    BTable,
    BRow,
    BCol,
    vSelect,
    BFormInput,
    BButton,
    BPagination,
    ApiTokensModal,
    BBadge,
  },
  data() {
    return {
      searchBy: 'All',
      loader: false,
      apiTokensData: [],
      perPage: 10,
      perPageOptions: [10, 25, 50, 100],
      searchByOptions: ['All', 'Active', 'Inactive'],
      searchQuery: '',
      totalPages: 0,
      from: 0,
      to: 0,
      currentPage: 1,
      editData: {},
      addApiToken: {
        id: 0,
        client_id: '',
        secret: '',
        name: '',
        description: '',
        parent_id: JSON.parse(localStorage.getItem('userData')).data.id,
      },
      user_type: JSON.parse(localStorage.getItem('userData')).data.user_type,
      modalLoader: true,
      constants,
      isSuperAdmin: false,
    }
  },
  computed: {
    tableFields() {
      return [
        { key: 'id', sortable: true },
        { key: 'name', sortable: true, label: i18n.t('DEBTIA_TITLE') },
        { key: 'client_id', sortable: true, label: i18n.t('DEBTIA_CLIENT_ID') },
        { key: 'status', sortable: true, label: i18n.t('DEBTIA_STATUS') },
        { key: 'action', label: i18n.t('DEBTIA_ACTION') },
      ]
    },
  },
  watch: {
    searchQuery: {
      handler() {
        if (this.searchQuery.length === 0 && this.searchRun) {
          this.searchRun = false
          this.currentPage = 1
          this.getApiTokens()
        }
      },
    },
    currentPage: {
      handler() {
        this.getApiTokens()
      },
    },
    perPage: {
      handler() {
        this.currentPage = 1
        this.getApiTokens()
      },
    },
  },
  created() {
    this.getApiTokens()
    this.actionColumn()
  },
  methods: {
    searchRecords() {
      if (this.searchQuery.length > 0) {
        this.searchRun = true
        this.getApiTokens()
      }
    },
    async getApiTokens() {
      try {
        if (this.user_type === 'super-admin') {
          this.isSuperAdmin = true
        } else {
          this.isSuperAdmin = false
        }
        this.loader = true
        const apiTokens = await axios.get(`${constants.baseUrl}/api-token/list?perPage=${this.perPage}&q=${this.searchQuery}&page=${this.currentPage}`)
        this.loader = false
        if (apiTokens.status) {
          this.apiTokensData = apiTokens.data.data.api_tokens.data
          this.totalPages = apiTokens.data.data.api_tokens.total
          this.from = apiTokens.data.data.api_tokens.from
          this.to = apiTokens.data.data.api_tokens.to
          this.currentPage = apiTokens.data.data.api_tokens.current_page
          this.loader = false
        }
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: 'Error',
            icon: 'CoffeeIcon',
            variant: 'danger',
            text: error,
          },
        })
      }
    },
    apiToken(item) {
      this.modalLoader = true

      this.editData = item
      this.modalLoader = false
    },
    async deleteApiToken(id) {
      this.loader = true
      const apiTokens = await axios.post(`${constants.baseUrl}/api-token/delete/${id}`)
      if (apiTokens.status) {
        this.getApiTokens()
      }
      this.loader = false
    },
    async apiTokenStatus(id, status) {
      this.loader = true
      const st = status === 1 ? 0 : 1
      const apiTokens = await axios.post(`${constants.baseUrl}/api-token/revoke/${id}`,
        { status: st })
      if (apiTokens.status) {
        this.getApiTokens()
      }
      this.loader = false
    },
    confirmation(id, name, type, status) {
      // methodId
      let msg = ''
      if (type === 1) {
        msg = 'DEBTIA_DELETION_MSG'
      } else {
        msg = status === 1 ? 'DEBTIA_DEACTIVATE_MSG' : 'DEBTIA_ACTIVATE_MSG'
      }
      const question = ` '${name}' ?`
      this.$swal({
        title: i18n.t('DEBTIA_CAUTION'),
        text: i18n.t(msg) + question,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: i18n.t('DEBTIA_YES'),
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          if (type === 1) {
            this.deleteApiToken(id)
          } else {
            this.apiTokenStatus(id, status)
          }
        }
      })
    },
    actionColumn() {
      if (this.$ability.cannot(this.constants.action.permissionApiTokenEdit, this.constants.resource.apiToken) && this.$ability.cannot(this.constants.action.permissionApiTokenDelete, this.constants.resource.apiToken) && this.$ability.cannot(this.constants.action.permissionApiTokenRevoke, this.constants.resource.apiToken)) {
        this.tableFields.splice(4, 1)
      }
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
.query-input{
  padding: 0px
}

.search_by_select .vs__dropdown-toggle{
  width: 160px;
}
</style>
